import { FC, useState } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { currencyToApi, showAlert, useStores } from '~/utils';
import CreditSimulationValue from './CreditSimulationValue';
import {
  type CreditSimulationValueFormValues,
  initialValues,
  validationSchema,
} from './schema';

const CreditSimulationValueContainer: FC = () => {
  const { creditProducts } = useStores();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (values: CreditSimulationValueFormValues) => {
    try {
      setLoading(true);
      const formatedAmount = currencyToApi(values.creditSimulationValue);
      await creditProducts.getSimulationPlans(formatedAmount);
      navigate(Routes.CREDIT_SIMULATION_INSTALLMENTS);
    } catch (error) {
      showAlert({
        message: error.message || 'Erro ao buscar planos de simulação',
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <CreditSimulationValue loading={loading} />
    </FormBehavior>
  );
};
export default observer(CreditSimulationValueContainer);
